export const WorkoutIntro = {
  bindings: {
    title: '<',
    subTitle: '<',
    description: '<',
    videoId: '<',
  },

  template: `
    <div class="workout-intro bg-gray-100">
      <div class="row">
        <div class="col-lg-8">
          <video-player-resumable video-id="$ctrl.videoId">
          </video-player-resumable>
        </div>
        <div class="col-lg-4">
          <div class="p-4 pl-lg-0">
            <h2 ng-bind-html="$ctrl.title"></h2>
            <h5 class="text-gray" ng-bind-html="$ctrl.subTitle"></h5>
            <p class="mb-0" ng-bind-html="$ctrl.description"></p>
          </div>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Workout/WorkoutIntro.js